<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'post'"></ContentLoader>
    </div>
    <!-- class="carouselContainer" -->
    <div v-else>
      <div v-if="dataToShow && dataToShow.length">
        <Carousel>
          <div v-for="(d, i) in dataToShow" :key="i">
            <router-link
              :to="{
                name: 'UserTrainerPostView',
                params: { trainer_id: d.trainer_id, id: d.id },
              }"
            >
              <div
                class="bg-white ring-1 ring-gray-300 min-h-full mx-1 rounded-lg shadow duration-500 shadow-all flex flex-col w-full px-4 py-3 h-64"
              >
                <div class="flex items-center">
                  <div class="flex-shrink-0">
                    <Avatar
                      :classStr="'h-8 w-8 mr-2'"
                      :src="baseUrlSrc(d.thumbnail_url)"
                    />
                  </div>
                  <div class="w-4/5">
                    <p
                      class="text-sm capitalize text-gray-dark font-medium text-ellipses"
                    >
                      {{ d.name }}
                    </p>
                    <p class="text-xs -mt-1 text-gray-light text-ellipses">
                      {{ handleCreatedAt(d.updated_at) }}
                    </p>
                  </div>
                </div>
                <div class="mt-4">
                  <p
                    class="text-gray-light text-xs vertical-ellipses vertical-ellipses-lines break-all"
                  >
                    {{ d.body }}
                  </p>
                </div>
                <div class="flex flex-1 items-end mt-4">
                  <div class="flex items-center">
                    <button
                      v-if="d.is_liked"
                      class="focus:outline-none"
                      @click.prevent="handlePostLike(d.id, false)"
                    >
                      <HeartFill />
                    </button>

                    <button
                      v-else
                      class="focus:outline-none"
                      @click.prevent="handlePostLike(d.id, true)"
                    >
                      <Heart />
                    </button>

                    <p class="text-xs ml-1">
                      <span class="text-gray-dark font-medium">{{
                        d.like_counter
                      }}</span
                      ><span class="text-gray-light"> Likes</span>
                    </p>
                  </div>
                  <div class="flex items-center ml-3">
                    <Chat />
                    <p class="text-xs ml-1">
                      <span class="text-gray-dark font-medium">{{
                        d.total_comments
                      }}</span
                      ><span class="text-gray-light"> Comments</span>
                    </p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </Carousel>
      </div>
    </div>
    <div v-if="statusCode == 404 || statusCode == 401">
      <div
        class="flex md:flex-row flex-col items-center px-4 justify-around py-8"
      >
        <img
          :src="require(`@/assets/svg/upcoming-sessions.svg`)"
          class="w-40"
        />
        <div class="md:text-2xl md:px-10" v-if="statusCode == 404">
          <p>It looks empty...</p>
          <p>Follow Trainers to see their posts</p>
        </div>
        <router-link
          :to="{ name: 'TrainersFind' }"
          class="uppercase bg-green-light text-white px-2 py-1 rounded font-bold text-sm"
          v-if="statusCode == 404"
        >
          Find Trainers
        </router-link>
        <div class="md:text-2xl md:px-10" v-if="statusCode == 401">
          <p>It looks empty...</p>
          <p>Log In to see the Trainers posts</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Avatar, Carousel } from "@/components/t-components";
import { Heart, Chat, HeartFill } from "@/components/icons";
import { mapActions } from "vuex";

export default {
  name: "UserTrainerPostListCarousel",
  components: {
    Avatar,
    Chat,
    Heart,
    Carousel,
    ContentLoader,
    HeartFill,
  },
  props: {
    data: {
      type: Array,
      default: Array,
    },
    statusCode: {
      type: Number,
    },
  },
  data() {
    return {
      dataToShow: [],
    };
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  watch: {
    data: function () {
      this.dataToShow = this.data;
    },
  },
  methods: {
    ...mapActions(["postCommentLike", "getUserFollowedTrainerPosts"]),
    async handlePostLike(id, isLiked) {
      let is_liked = "";
      let likeCounter = "";
      if (isLiked) {
        is_liked = 1;
        likeCounter = 1;
      } else {
        is_liked = null;
        likeCounter = -1;
      }
      const data = {
        is_liked: 1,
        post_id: id,
      };

      this.dataToShow.map((item) => {
        if (item.id === id) {
          item.is_liked = is_liked;
          item.like_counter = item.like_counter + likeCounter;
        }
      });
      await this.postCommentLike(data);

      const query = {
        page: 1,
      };

      this.getUserFollowedTrainerPosts({ query });
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical-ellipses {
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vertical-ellipses-lines {
  -webkit-line-clamp: 8;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>